const detectLanguageData = (data = null, language = 'th') => {
  return data[language] || data['th'];
}

export default detectLanguageData;